/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Citations_TitleInputs */

const en_why_listening_citations_title = /** @type {(inputs: Why_Listening_Citations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citations off. Sections kept.`)
};

const es_why_listening_citations_title = /** @type {(inputs: Why_Listening_Citations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin citas. Con secciones.`)
};

/**
* | output |
* | --- |
* | "Citations off. Sections kept." |
*
* @param {Why_Listening_Citations_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_citations_title = /** @type {((inputs?: Why_Listening_Citations_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Citations_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_citations_title(inputs)
	return en_why_listening_citations_title(inputs)
});